<template>
  <div class="registration-page">
    <section class="registration-header">
      <h1 class="page-heading">RSVP for How To Build Your Career</h1>
      <p class="page-intro">
        We're hosting a panel discussion about different paths into the film
        industry!
      </p>
      <div class="text-center">
        <v-btn
          @click="openRegistrationDialog"
          color="white"
          class="share-memory-btn v-btn--emphasis"
          >Register Now</v-btn
        >
        <v-dialog
          persistent
          max-width="990"
          v-if="registrationDialog"
          v-model="registrationDialog"
        >
          <v-card>
            <RegistrationFormHowToBuild @close="registrationDialog = false" />
          </v-card>
        </v-dialog>
      </div>
    </section>
  </div>
</template>

<script>
import formMixin from "@/mixins/form.mixin";

export default {
  name: "RegistrationPageHowToBuild",
  metaInfo: {
    titleTemplate: "%s - Registration"
  },
  extends: formMixin,
  data() {
    return {
      registrationDialog: false,
      loading: false
    };
  },
  methods: {
    openRegistrationDialog() {
      this.registrationDialog = true;
    }
  }
};
</script>

<style scoped lang="scss">
.registration-page {
  color: $cmf-darkgrey;
}
.registration-header {
  padding: 80px 40px;
  text-align: center;
}
</style>
